"use client";

import { motion } from "framer-motion";
import Image from "next/image";

export default function PromiseSection() {
  const images = [
    "/img1.avif",
    "/img1.avif",
    "/img1.avif",
    "/img1.avif",
  ];

  return (
    <section className="w-full bg-white flex items-center justify-center font-[BOOWIE] py-6 sm:py-8 md:py-10 lg:py-12">
      <div
        className="
          flex flex-col md:flex-row
          items-center justify-between
          gap-10 lg:gap-16
          max-w-[1400px] w-full
          px-4 sm:px-6 lg:px-10 xl:px-16
        "
      >
        {/* Left Side */}
        <div className="flex flex-col items-start max-w-md w-full text-left">
          <div className="flex items-center gap-4 mb-4">
            <Image
              src="/Artha.png"
              alt="Logo 1"
              width={48}
              height={48}
              className="h-12 sm:h-16 w-auto"
            />

            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold leading-tight">
              OUR PROMISE TO INDIA!
            </h2>
          </div>

          <p className="font-sans text-sm sm:text-base leading-relaxed tracking-tight text-gray-600 text-justify">
            Gitartha is born from a singular dream to become the trusted
            platform for every Indian need. We envision a nation where
            financial literacy is widespread, legal support is accessible,
            property ownership is attainable, and every brand finds its voice.
          </p>
        </div>

        {/* Center Scrolling Images */}
        {/* <div className="h-64 sm:h-80 md:h-[400px] w-40 sm:w-52 md:w-60 overflow-hidden rounded-xl flex-shrink-0">
          <motion.div
            initial={{ y: 0 }}
            animate={{ y: ["0%", "-100%"] }}
            transition={{
              duration: images.length * 4,
              repeat: Infinity,
              ease: "linear",
            }}
            className="flex flex-col"
          >
            {images.concat(images).map((src, index) => (
              <div
                key={index}
                className="h-64 sm:h-80 md:h-[400px] w-full flex-shrink-0 my-2 sm:my-3"
              >
                <Image
                  src={src}
                  alt={`Image ${index}`}
                  width={300}
                  height={600}
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
            ))}
          </motion.div>
        </div> */}

        {/* Right Side */}
        <div className="flex flex-col items-start max-w-md w-full text-left">
          <Image
            src="/Artha.png"
            alt="Logo 2"
            width={200}
            height={400}
            className="w-28 sm:w-32 md:w-40 mb-4"
          />

          <p className="font-sans text-sm sm:text-base leading-relaxed tracking-tight text-gray-600 text-justify">
            We don&apos;t just provide services. We are a movement of
            empowerment, connecting people to possibilities, dreams to
            realities, and ambition to action. Gitartha stands for integrity,
            innovation, and India.
          </p>
        </div>
      </div>
    </section>
  );
}